import { Component, OnInit, ViewChildren, AfterViewInit, QueryList } from '@angular/core';
import {
  AssemblyAction,
  DictionaryValues,
  GenericElementViewsEntity,
  AttributesEntity
} from '../../models/configuration.model';
import { Map } from '../../models/objects.model';
import { BafAgentService } from '../../core/services/baf-agent/baf-agent.service';
import { CustomService } from '../../services/custom/custom.service';
import { DataStoreService } from '../../core/services/data-store/data-store.service';
import { DictionaryStoreService } from '../../services/dictionary-store/dictionary-store.service';
import { NotificationService } from '../../services/notification/notification.service';
import { DocumentSigningService } from '../../services/document-signing/document-signing.service';
import { FunctionStoreService } from '../../services/function-store/function-store.service';
import { FileSelectionStoreService } from '../../services/file-selection-store/file-selection-store.service';
import { SignFileInfo } from '../../services/document-signing/sign-file-info';
import { ProfileStoreService } from '../../services/profile-store/profile-store.service';
import { UploadService } from '../../services/upload/upload.service';
import { DialogControllerService } from '../../services/dialog-controller/dialog-controller.service';
import { UploadState } from '../../services/upload/upload-state';
import { ReceiverSelectorComponent } from '../receiver-selector/receiver-selector.component';

// TODO MK-REF
// TODO Dodać binding elementów formularza zgodnie mechanizmami z Angulara.

@Component({
  selector: 'baf-single-view',
  templateUrl: './single-view.component.html',
  styleUrls: ['./single-view.component.css']
})
export class SingleViewComponent implements OnInit, AfterViewInit {
  private recentElementId = '';
  readonly validFileExtensions = ['gml', 'xml', 'pdf', 'zip', '7z'];
  isPopupVisible = false;
  htmlToAdd = '';
  attributes: AttributesEntity[] = [];
  popupTitle: string;
  isCertificateMissing = false;
  isDataProcessing = false;
  certificateStatus: string;
  currentView: GenericElementViewsEntity;
  values: DictionaryValues;
  xml: string;

  @ViewChildren(ReceiverSelectorComponent)
  private receiverSelectors: QueryList<ReceiverSelectorComponent>;

  constructor(
    private storeService: DataStoreService,
    private dictionaryStore: DictionaryStoreService,
    private bafAgent: BafAgentService,
    private upload: UploadService,
    private customService: CustomService,
    private signingService: DocumentSigningService,
    private functionStore: FunctionStoreService,
    private profileStore: ProfileStoreService,
    private fileStore: FileSelectionStoreService,
    private dialogController: DialogControllerService,
    private notifier: NotificationService
  ) {
    storeService.getShowGrid().subscribe(gridVisible => {
      this.isPopupVisible = !gridVisible;
      if (this.isPopupVisible) {
        this.isDataProcessing = true;
        this.loadComponents();
        this.isDataProcessing = false;
      }
    });
  }

  private loadComponents() {
    if (this.storeService.currentElementId !== '') {
      if (!this.storeService.currentElementId) {
        return;
      }

      this.currentView = this.storeService
        .getConfiguration()
        .businessModel.elements.find(e => e.id === this.storeService.currentElementId)
        .genericElementViews.find(e => e.id === this.storeService.currentElementViewId);

      this.popupTitle = this.currentView.displayName.name;
      this.attributes = this.currentView.attributes;

      const id = this.storeService.currentElementId;
      const isStored = this.signingService.isCertificateStoredValue;
      // TODO Zmienić na odczyt z konfiguracji po uzupełnieniu struktury
      this.isCertificateMissing = this.needCertificate(id) && !isStored;
      this.certificateStatus = isStored ? '' : 'Brak zarejestrowanego certyfikatu!';
      if (id !== this.recentElementId) {
        this.fileStore.clear();
        this.recentElementId = id;
      }

      setTimeout(() => this.reloadReceivers());
    }
  }

  private needCertificate(id: string): boolean {
    return id.indexOf('NOT-EGIB-SINGLE') >= 0 || id.indexOf('EGIB-NKW') >=0 || id.indexOf('EGIB-OP') >= 0;
  }

  private getValues(values: DictionaryValues) {
    this.values = values;
    for (const ae of this.attributes) {
      ae.value = this.values[0][ae.businessModelElementAttrId];

      if (ae.businessType === 4) {
        if (ae.value != null) {
          ae.value = ae.value.substr(0, 10);
        }
      }

      if (ae.businessType === 5) {
        if (ae.value != null) {
          this.dictionaryStore
            .getDictionary(
              ae.businessModelElementAttrId,
              ae.value,
              '"ELEMENT.WNIOSKI',
              'EDYCJA_WNIOSKU'
            )
            .subscribe(result => (ae.dirValue = result));
        }
      }
    }
  }

  onFileSelected(file: File) {}

  onButtonClick(functionId: string) {
    if (this.validateParameters()) {
      this.isDataProcessing = true;
      const values: Map = {};
      this.forEachAttributeInput(
        (attribute, input) => (values[attribute.id.replace('ADD-', '')] = input.value)
      );
      this.addSignatureFile(values).then(() => {
        this.saveFormData(functionId, values);
      });
    }
  }

  private saveFormData(functionId: string, values: Map) {
    this.customService.fillZSIN(values);

    const currentFunction = this.currentView.functions.find(func => func.id === functionId);
    const assemblyAction: AssemblyAction = currentFunction.action as AssemblyAction;

    if (assemblyAction != null) {
      const form = new FormData();
      form.append('assemblyAction', JSON.stringify(assemblyAction));
      form.append('data', JSON.stringify(values));
      for (let index = 0; index < this.fileStore.files.length; index++) {
        form.append('files', this.fileStore.files[index], this.fileStore.files[index].name);
      }
      this.uploadData(form);
    } else {
      this.bafAgent
        .saveData(
          this.storeService.currentElementId,
          this.storeService.currentElementViewId,
          this.storeService.currentId,
          JSON.stringify(values)
        )
        .subscribe(data => {
          this.getValues(data);
        });
    }
  }

  private validateParameters(): boolean {
    for (const ae of this.attributes) {
      if (ae.businessType !== 7 && ae.businessType !== 9) {
        const value = document.getElementById(ae.id).getElementsByTagName('input')[0].value;
        if (ae.required && ae.displayMode === 2 && !value) {
          this.notifier.error(`Brak uzupełnionego wymaganego atrybutu "${ae.displayName.name}".`);
          return false;
        }
      }
    }

    if (this.fileStore.files.length === 0) {
      this.notifier.error('Brak plików do zarejestrowania');
      return false;
    }

    for (const file of this.fileStore.files) {
      const fileExt = file.name
        .split('.')
        .pop()
        .toLowerCase();
      if (!this.validFileExtensions.includes(fileExt)) {
        this.notifier.error(`Nieobsługiwany format pliku ${file.name}`);
        return false;
      }
    }

    return true;
  }

  private addSignatureFile(values: Map): Promise<void> {
    if (this.needCertificate(this.currentView.id)) {
      const signFileInfo = this.createSignFileInfo(values);
      return new Promise(resolve => {
        this.profileStore.restoreCertificatePassword().subscribe(password => {
          this.signingService
            .signFiles(this.fileStore.files, signFileInfo, password)
            .then(signatureFile => {
              this.fileStore.add(signatureFile);
              resolve();
            });
        });
      });
    } else {
      return Promise.resolve();
    }
  }

  private createSignFileInfo(values: Map): SignFileInfo {
    /*const signFileInfo = new SignFileInfo();
    signFileInfo.changeIdentifier = '';
    signFileInfo.sequenceNumber = '';

    return signFileInfo;*/
    return this.customService.getSignFileInfo(values);
  }

  private uploadData(form: FormData) {
    let started = false;
    this.upload.uploadData(form).subscribe(
      event => {
        if (!started) {
          this.isPopupVisible = false;
          this.dialogController.openUploadDialog();
          started = true;
        }
        switch (event.state) {
          case UploadState.Started:
            break;
          case UploadState.Progress:
            break;
          case UploadState.Finished:
            if (event.data === -1) {
              this.notifier.success('Pliki zostały zarejestrowane w repozytorium GUGiK.');
            } else {
              this.notifier.success('Zarejestrowano zawiadomienie numer ' + event.data);
            }
            this.afterSuccessfulRegistration();
            this.dialogController.closeDialog();
            this.isPopupVisible = false;
            break;
        }
      },
      error => {
        this.notifier.error(
          'Wystąpił błąd podczas rejestracji zawiadomienia: ' + error.error.Message
        );
        this.dialogController.closeDialog();
        this.isPopupVisible = false;
      }
    );
  }

  private reloadReceivers() {
    if (this.receiverSelectors) {
      this.receiverSelectors.forEach(selector => selector.reload());
    }
  }

  private afterSuccessfulRegistration() {
    if (this.receiverSelectors) {
      this.receiverSelectors.forEach(selector => selector.updateStatistics());
    }
    this.clearInputValues();
    this.functionStore.refreshFunctions();
    this.storeService.refreshNode();
  }

  private clearInputValues() {
    this.forEachAttributeInput((attribute, input) => (input.value = null));
    if (this.receiverSelectors) {
      this.receiverSelectors.forEach(selector => selector.clearSelection());
    }
    this.fileStore.clear();
  }

  private forEachAttributeInput(
    action: (attribute: AttributesEntity, input: HTMLInputElement) => void
  ): void {
    for (const attribute of this.attributes) {
      if (attribute.businessType !== 7 && attribute.businessType !== 9) {
        const input = document.getElementById(attribute.id).getElementsByTagName('input')[0];
        action(attribute, input);
      }
    }
  }

  ngAfterViewInit() {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/components/single-view/single-view.component.ts